<template>
  <div
    ref="kt_modal_estoque_movimentacao"
    data-bs-backdrop="static"
    class="modal fade modal-overlay"
    tabindex="-1"
    id="kt_modal_estoque_movimentacao"
  >
    <div
      class="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <div class="card-title d-flex align-items-center">
            <span class="svg-icon svg-icon-1 svg-icon me-3 lh-0">
              <inline-svg src="media/icons/duotune/general/gen017.svg" />
            </span>
            <h3 class="fw-bold m-0 text-gray-800">
              Movimentar quantidade de estoque
            </h3>
          </div>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary"
            data-bs-dismiss="modal"
            @click="$emit('exibirModalEstoqueMovimentacao', false)"
          >
            <span class="svg-icon svg-icon-1 svg-icon lh-0">
              <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body p-4">
          <div class="card border border-rounded border-gray-300 mb-10 p-6">
            <div class="row">
              <div class="col-6 fv-row d-flex justify-content-center">
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="rbOperacao"
                    id="rbEntrada"
                    :checked="this.estoqueMovimentacao.operacao === 'E'"
                    @change="
                      (this.estoqueMovimentacao.operacao = 'E'),
                        this.nextFocus('txtQtdInformada')
                    "
                  />
                  <label class="form-check-label fs-6 fw-bold" for="rbEntrada">
                    F3 - Entrada
                  </label>
                </div>
              </div>
              <div class="col-6 fv-row d-flex justify-content-center">
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="rbOperacao"
                    id="rbSaida"
                    :checked="this.estoqueMovimentacao.operacao === 'S'"
                    @change="
                      (this.estoqueMovimentacao.operacao = 'S'),
                        this.nextFocus('txtQtdInformada')
                    "
                  />
                  <label class="form-check-label fs-6 fw-bold" for="rbSaida">
                    F4 - Saída
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 mb-4">
              <div
                class="fv-row flex-column d-flex align-items-center text-center"
              >
                <CurrencyInput
                  id="txtQtdInformada"
                  class="form-control fs-3"
                  style="text-align: center"
                  v-model="this.estoqueMovimentacao.qtd_informada"
                  :options="options"
                  v-on:keyup.enter="this.confirmarEstoqueMovimentacao()"
                  @keyup="onPressInputQtd"
                ></CurrencyInput>
                <div class="fv-plugins-message-container invalid-feedback">
                  {{ errosValidacao["qtd_informada"] }}
                </div>
              </div>
            </div>
            <div class="col-12 mb-4">
              <div
                class="fv-row flex-column d-flex align-items-center text-center text-warning"
              >
                <div class="input-group">
                  <span class="input-group-text fs-4 min-w-175px"
                    >Quantidade atual:
                  </span>
                  <CurrencyInput
                    id="txtQtdAnterior"
                    class="form-control fs-3 bg-light-warning"
                    style="text-align: center"
                    v-model="this.estoqueMovimentacao.qtd_anterior"
                    :options="options"
                    readonly
                  ></CurrencyInput>
                </div>
                <div class="fv-plugins-message-container invalid-feedback">
                  {{ errosValidacao["qtd_anterior"] }}
                </div>
              </div>
            </div>
            <div class="col-12 mb-4">
              <div
                class="fv-row flex-column d-flex align-items-center text-center text-danger"
              >
                <div class="input-group">
                  <span class="input-group-text fs-4 min-w-175px"
                    >Quantidade final:
                  </span>
                  <CurrencyInput
                    id="txtQtdFinal"
                    class="form-control fs-3 bg-light-danger"
                    style="text-align: center"
                    v-model="this.estoqueMovimentacao.qtd_final"
                    :options="options"
                    readonly
                  ></CurrencyInput>
                </div>
                <div class="fv-plugins-message-container invalid-feedback">
                  {{ errosValidacao["qtd_final"] }}
                </div>
              </div>
            </div>
            <div class="col-12 mb-4">
              <div class="fv-row">
                <label class="form-label">Observações</label>
                <textarea
                  id="txtObservacoes"
                  class="form-control mb-2"
                  maxlength="300"
                  style="height: 100px"
                  v-model="this.estoqueMovimentacao.obs"
                />
                <div class="row">
                  <div class="col-6 pe-0">
                    <div
                      class="fv-plugins-message-container invalid-feedback m-0"
                    >
                      {{ errosValidacao["obs"] }}
                    </div>
                  </div>
                  <div class="col-6 ps-2">
                    <div class="text-end text-muted fs-7">
                      {{
                        this.estoqueMovimentacao.obs !== null
                          ? this.estoqueMovimentacao.obs.length
                          : 0
                      }}/300 caracteres
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 mb-4">
              <div class="fv-row">
                <div class="d-flex justify-content-between">
                  <label class="form-label me-4">Detalhes da operação</label>
                  <div class="card-toolbar">
                    <button
                      v-if="this.consultarEstoqueMoviOperacao"
                      type="button"
                      @click="modalEstoqueMoviOperacoes(true)"
                      class="btn btn-sm btn-secondary px-2 py-0 m-0"
                    >
                      <span class="svg-icon svg-icon-1 m-0">
                        <inline-svg
                          src="media/icons/duotune/general/gen041.svg"
                      /></span>
                    </button>
                  </div>
                </div>
                <select
                  class="form-select mb-0"
                  data-placeholder="Selecione uma opção"
                  v-model="this.estoqueMovimentacao.operacao_movimentacao"
                >
                  <template v-for="operacao in this.operacoes" :key="operacao">
                    <option
                      :value="operacao.descricao"
                      v-bind:selected="[
                        operacao.descricao ===
                        this.estoqueMovimentacao.operacao_movimentacao
                          ? 'selected'
                          : '',
                      ]"
                    >
                      {{ operacao.descricao }}
                    </option>
                  </template>
                </select>
                <div class="fv-plugins-message-container invalid-feedback">
                  {{ errosValidacao["operacao_movimentacao"] }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="d-flex justify-content-between col-12">
            <div>
              <button
                v-if="this.consultarEstoqueMovimentacao"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="Histórico de movimentação"
                class="d-flex justify-content-center align-items-center btn-bg-light btn btn-light-primary svg-icon-white px-3"
                @click="this.modalEstoqueMovimentacoes(true)"
              >
                <i class="bi bi-clock-history ms-1 mt-1 fs-2"></i>
              </button>
            </div>
            <div>
              <button
                class="btn btn-danger svg-icon-white me-2 mb-2"
                data-bs-dismiss="modal"
                @click="$emit('exibirModalEstoqueMovimentacao', false)"
              >
                <span class="svg-icon svg-icon-1">
                  <inline-svg
                    src="media/icons/duotune/arrows/arr015.svg"
                    class="me-2"
                  />Cancelar
                </span>
              </button>
              <button
                class="btn btn-success svg-icon-white mb-2"
                type="submit"
                v-bind:data-kt-indicator="loadingConfirmar ? 'on' : 'off'"
                @click.prevent="confirmarEstoqueMovimentacao()"
              >
                <span class="indicator-progress">
                  <span
                    class="spinner-border spinner-border-sm align-middle ms-1"
                  ></span>
                  Aguarde...
                </span>
                <span class="svg-icon svg-icon-1" v-if="!loadingConfirmar">
                  <inline-svg
                    src="media/icons/duotune/arrows/arr016.svg"
                    class="me-2"
                  />Confirmar
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <EstoqueMoviOperacoesModal
    v-if="exibirEstoqueMoviOperacoes"
    @exibirModalEstoqueMoviOperacoes="modalEstoqueMoviOperacoes"
    @confirmarEstoqueMoviOperacao="carregarOperacoes"
  ></EstoqueMoviOperacoesModal>
  <EstoqueMovimentacoesModal
    v-if="exibirEstoqueMovimentacoes"
    :idEstoque="this.estoque.id"
    @exibirModalEstoqueMovimentacoes="modalEstoqueMovimentacoes"
  ></EstoqueMovimentacoesModal>
</template>

<script>
import { mapState } from "vuex";
import CurrencyInput from "@/components/text/CurrencyInput";
import EstoqueMoviOperacoesModal from "../produtos/EstoqueMoviOperacoesModal.vue";
import EstoqueMovimentacoesModal from "../produtos/EstoqueMovimentacoesModal.vue";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { hideModal, getOrCreateInstanceModal } from "@/core/helpers/dom";
import { useToast } from "vue-toastification";
const toast = useToast();

export default {
  emits: ["exibirModalEstoqueMovimentacao", "confirmarEstoqueMovimentacao"],
  components: {
    CurrencyInput,
    EstoqueMoviOperacoesModal,
    EstoqueMovimentacoesModal,
  },
  props: {
    estoque: { type: Object, required: false },
  },
  methods: {
    modalEstoqueMovimentacoes(exibir) {
      this.exibirEstoqueMovimentacoes = exibir;
      if (exibir === true) {
        setTimeout(() => {
          getOrCreateInstanceModal("kt_modal_estoque_movimentacoes_consultar");
        }, 100);
      }
    },
    onPressInputQtd(e) {
      if (e.key === "F3") {
        this.estoqueMovimentacao.operacao = "E";
      }
      if (e.key === "F4") {
        this.estoqueMovimentacao.operacao = "S";
      }
    },
    modalEstoqueMoviOperacoes(exibir) {
      this.exibirEstoqueMoviOperacoes = exibir;
      if (exibir === true) {
        setTimeout(() => {
          getOrCreateInstanceModal("kt_modal_estoque_movi_operacoes_consultar");
        }, 100);
      }
    },
    async carregarOperacoes() {
      try {
        var ret = await this.$store.dispatch(
          "estoqueMoviOperacao/getEstoqueMoviOperacaoOData",
          ""
        );
        if (ret.value !== null && ret.value.length > 0) {
          this.operacoes = ret.value;
        }
      } catch (error) {
        console.log(error);
        this.confirmouCadastro = false;
      }
    },
    async confirmarEstoqueMovimentacao() {
      this.errosValidacao = [];
      this.confirmouCadastro = true;
      this.loadingConfirmar = true;
      if (
        this.estoqueMovimentacao.qtd_informada === undefined ||
        this.estoqueMovimentacao.qtd_informada === null ||
        !this.$utils.isNumber(this.estoqueMovimentacao.qtd_informada)
      ) {
        this.errosValidacao = {
          qtd_informada: "A quantidade deve ser do tipo numérico!",
        };
        this.nextFocus("txtQtdInformada");
      } else if (this.estoqueMovimentacao.qtd_informada <= 0) {
        this.errosValidacao = {
          qtd_informada: "A quantidade deve ser maior que zero!",
        };
        this.nextFocus("txtQtdInformada");
      } else if (this.estoqueMovimentacao.qtd_final < 0) {
        await Swal.fire({
          text: "A quantidade final não pode ser negativa!",
          icon: "warning",
          buttonsStyling: false,
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn fw-bold btn-warning",
          },
        });
        this.errosValidacao = {
          qtd_final: "A quantidade final não pode ser negativa!",
        };
      } else {
        this.estoqueMovimentacao.data = new Date();
        this.estoqueMovimentacao.guid = this.$utils.generateUuidv4();
        this.estoqueMovimentacao.id_estoque = this.estoque.id;
        this.estoqueMovimentacao.id_usuario = this.user.User.id;
        try {
          var ret = await this.$store.dispatch(
            "estoqueMovimentacao/postEstoqueMovimentacao",
            this.estoqueMovimentacao
          );
          if (ret.Success === true) {
            await this.confirmarEstoque();
          }
        } catch (error) {
          this.errosValidacao = error;
          this.confirmouCadastro = false;
        }

        if (this.confirmouCadastro === true) {
          this.$emit(
            "confirmarEstoqueMovimentacao",
            this.estoqueMovimentacao.qtd_final
          );
          hideModal(this.$refs.kt_modal_estoque_movimentacao);
          this.$emit("exibirModalEstoqueMovimentacao", false);

          toast.success("Estoque salvo com sucesso!", { timeout: 2000 });
        } else {
          toast.error("Ocorreu uma falha ao atualizar o estoque, verifique!", {
            timeout: 5000,
          });
        }
      }

      this.loadingConfirmar = false;
    },
    async confirmarEstoque() {
      let est = JSON.parse(JSON.stringify(this.estoque));
      est.qtd = this.estoqueMovimentacao.qtd_final;
      try {
        var ret = await this.$store.dispatch("estoque/putEstoque", est);
      } catch (error) {
        this.errosValidacao = error;
        this.confirmouCadastro = false;
      }
    },
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
        document.getElementById(id).select();
      }
    },
    async verificarRestricoes() {
      if (this.user.User.EmitenteTipoUsuario.EmitenteRestricao != null) {
        this.user.User.EmitenteTipoUsuario.EmitenteRestricao.find((element) => {
          if (element.regra === "Permitir.EstoqueMovimentacao.Consultar") {
            this.consultarEstoqueMovimentacao = true;
          }

          if (element.regra === "Permitir.EstoqueMoviOperacao.Consultar") {
            this.consultarEstoqueMoviOperacao = true;
          }
        });
      }
    },
  },
  async mounted() {
    await this.verificarRestricoes();
    this.keyListener = (e) => {
      if (e.key === "F3") {
        e.preventDefault();
      } else if (e.key === "F4") {
        e.preventDefault();
      }
    };
    window.addEventListener("keydown", this.keyListener);
    this.errosValidacao = [];
    this.confirmouCadastro = true;
    this.estoqueMovimentacao.qtd_anterior = this.estoque.qtd;
    this.carregarOperacoes();
    setTimeout(() => {
      this.nextFocus("txtQtdInformada");
    }, 800);
  },
  beforeUnmount() {
    window.removeEventListener("keydown", this.keyListener);
  },
  watch: {
    atualizaQtdFinal(newVal) {
      this.estoqueMovimentacao.qtd_final = newVal;
    },
  },
  computed: {
    ...mapState("auth", ["user"]),
    atualizaQtdFinal() {
      let quantidade = this.estoqueMovimentacao.qtd_informada;
      let qtd_atual = this.estoqueMovimentacao.qtd_anterior;

      if (this.estoqueMovimentacao.operacao === "E") {
        return qtd_atual + quantidade;
      } else {
        return qtd_atual - quantidade;
      }
    },
  },
  data() {
    return {
      consultarEstoqueMovimentacao: false,
      consultarEstoqueMoviOperacao: false,
      loadingConfirmar: false,
      confirmouCadastro: true,
      errosValidacao: [],
      exibirEstoqueMovimentacoes: false,
      exibirEstoqueMoviOperacoes: false,
      operacoes: [],
      estoqueMovimentacao: {
        id: 0,
        data: null,
        id_usuario: null,
        id_estoque: null,
        qtd_anterior: 0,
        qtd_informada: 0,
        qtd_final: 0,
        guid: "",
        operacao: "E",
        obs: "",
        operacao_movimentacao: "",
      },
      options: {
        locale: "pt-BR",
        currency: "BRL",
        currencyDisplay: "hidden",
        precision: 2,
        hideCurrencySymbolOnFocus: false,
        hideGroupingSeparatorOnFocus: false,
        hideNegligibleDecimalDigitsOnFocus: false,
        autoDecimalDigits: true,
        autoSign: true,
        useGrouping: true,
        accountingSign: true,
      },
    };
  },
};
</script>

<style></style>
